import React, { Component } from "react";
import CheckListItems from "./CheckListItems";
import { Button, Row, Col } from "reactstrap";

export default class CheckList extends Component {
  constructor(props) {
    super(props);
    this.addNewOption = this.addNewOption.bind(this);
    this.removeOption = this.removeOption.bind(this);
    this.handleChangeItem = this.handleChangeItem.bind(this);
  }

  addNewOption() {
    const { data, handleChange } = this.props;
    let newitems = [...data.items];
    newitems.push({ title: "", value: false });
    handleChange({ name: "items", value: newitems });
  }
  removeOption(idx) {
    const { data, handleChange } = this.props;
    let olditems = [...data.items];
    if (olditems.length <= 1){
      return false
    }

    // newitems.splice(idx, 1);
    let newitems = [];
    for (let i = 0; i < olditems.length; i++) {
      if (i !== idx) newitems.push(olditems[i]);
    }

    handleChange({ name: "items", value: newitems });
  }

  handleChangeItem(event, index) {
    const { data, handleChange } = this.props;
    let olditems = [...data.items];
    let  _dt = event.target
    if(typeof event.target === "undefined") {
      _dt = event;
    }
    
    const { name, value } = _dt;
    olditems[index][name] = value;
    handleChange({ name: "items", value: olditems });
  }

  render() {
    const { data } = this.props;
    let _this = this;
    return (
      <div>
        <h4>Checklist items</h4>
        <Row>
          <Col md="1">
            <label> # </label>
          </Col>
          <Col md="5">Checkbox Name </Col>
          <Col md="2">Default Value</Col>
          <Col md="4"> Actions</Col>
        </Row>
        {typeof data.items === "object" &&
          data.items.map(function (item, idx) {
            return (
              <CheckListItems
                key={idx}
                idx={idx}
                item={item}
                isShowDelete={(data.items.length > 1)}
                handleChange={_this.handleChangeItem}
                removeOption={() => _this.removeOption(idx)}
              />
            );
          })}
        <Button className="btn-sm" color="danger" onClick={this.addNewOption}>
          <i className={"fa fa-plus"}></i> Add Another Item
        </Button>
      </div>
    );
  }
}
